export default __webpack_public_path__ + "static/media/icon_lg.f43e5481.svg";